module.exports = {"230202001":"五龙街道","230202002":"湖滨街道","230202003":"江安街道","230202004":"正阳街道","230202005":"彩虹街道","230202006":"南航街道","230202007":"大民街道","230202579":"齐齐哈尔局直"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230202.json
// module id = 690
// module chunks = 0